"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrilliantShieldAbilityHandler = exports.BrilliantShieldActorAbilityFactory = exports.BrilliantShieldAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Settings_1 = require("../../Settings");
class BrilliantShieldAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BrilliantShield;
        this.__typeName = "BrilliantShield";
    }
}
exports.BrilliantShieldAbilityArgs = BrilliantShieldAbilityArgs;
let BrilliantShieldActorAbilityFactory = class BrilliantShieldActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BrilliantShield", "AllAllies", 4);
    }
};
BrilliantShieldActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BrilliantShield")
], BrilliantShieldActorAbilityFactory);
exports.BrilliantShieldActorAbilityFactory = BrilliantShieldActorAbilityFactory;
let BrilliantShieldAbilityHandler = class BrilliantShieldAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies).forEach(targetId => {
                    container.applyBuff({
                        creatorId: ability.invokerId,
                        targetId,
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, Settings_1.BASE_LEVEL_ADR * container.getLevel(ability.invokerId)),
                            new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Will, container.getPercentOfBaseAttributeScore(targetId, 10, "Will")),
                        ], false),
                        duration: Duration_1.Duration.Turns(4),
                        sequence: sequence.pushSequence("sequential"),
                    });
                });
            }
        });
    }
};
BrilliantShieldAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BrilliantShield)
], BrilliantShieldAbilityHandler);
exports.BrilliantShieldAbilityHandler = BrilliantShieldAbilityHandler;
